"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRouterSchemaOverrides = void 0;
const protocol_router_api_1 = require("@moojo/protocol-router-api");
const serving_box_client_1 = require("@moojo/serving-box-client");
const web_transfer_1 = require("@moojo/web-transfer");
const crypto = __importStar(require("crypto"));
const protocolRouterUrl = 'https://tau1sze5ea.execute-api.eu-central-1.amazonaws.com/d/protocolRouterService';
const hostInstanceId = crypto.randomUUID();
const getRouterSchemaOverrides = async (logger, network, sdkVersion, sdkType, sdkInstanceId, dAppAddress) => {
    try {
        const client = new serving_box_client_1.ServiceClient(logger, protocol_router_api_1.protocolRouterServiceDeclaration, (0, web_transfer_1.createApiTransfer)(protocolRouterUrl), 'envelope');
        const overrides = await client.callEndpoint('getSchemaOverrides', {
            network,
            sdkType,
            sdkVersion,
            sdkInstanceId,
            dAppAddress,
            hostInstanceId,
        });
        if (logger.isDebugEnabled()) {
            logger.debug(`Protocol router schema: ${JSON.stringify(overrides, undefined, 2)}`);
        }
        return {
            openSchema: { ...overrides.openLayer, urlOrProvider: overrides.openLayer?.url },
            secretSchema: { ...overrides.secretLayer, urlOrProvider: overrides.secretLayer?.url },
            serviceEndpoints: overrides.endpoints,
        };
    }
    catch (error) {
        logger.debug(`Error reading schema from protocol router service.`, error);
        // Ignore any router errors, let the SDK stick to currently known schema.
        // TODO: reconsider this.
        return {};
    }
};
exports.getRouterSchemaOverrides = getRouterSchemaOverrides;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXJvdXRlci1zY2hlbWEtb3ZlcnJpZGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dldC1yb3V0ZXItc2NoZW1hLW92ZXJyaWRlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBLG9FQUE2RTtBQUM3RSxrRUFBeUQ7QUFDekQsc0RBQXVEO0FBQ3ZELCtDQUFnQztBQUloQyxNQUFNLGlCQUFpQixHQUFHLG1GQUFtRixDQUFBO0FBRTdHLE1BQU0sY0FBYyxHQUFHLE1BQU0sQ0FBQyxVQUFVLEVBQUUsQ0FBQTtBQUVuQyxNQUFNLHdCQUF3QixHQUFHLEtBQUssRUFDM0MsTUFBYyxFQUNkLE9BQWdCLEVBQ2hCLFVBQWtCLEVBQ2xCLE9BQWUsRUFDZixhQUFxQixFQUNyQixXQUFrQyxFQUNYLEVBQUU7SUFDekIsSUFBSSxDQUFDO1FBQ0gsTUFBTSxNQUFNLEdBQUcsSUFBSSxrQ0FBYSxDQUM5QixNQUFNLEVBQ04sc0RBQWdDLEVBQ2hDLElBQUEsZ0NBQWlCLEVBQUMsaUJBQWlCLENBQUMsRUFDcEMsVUFBVSxDQUNYLENBQUE7UUFDRCxNQUFNLFNBQVMsR0FBRyxNQUFNLE1BQU0sQ0FBQyxZQUFZLENBQUMsb0JBQW9CLEVBQUU7WUFDaEUsT0FBTztZQUNQLE9BQU87WUFDUCxVQUFVO1lBQ1YsYUFBYTtZQUNiLFdBQVc7WUFDWCxjQUFjO1NBQ2YsQ0FBQyxDQUFBO1FBRUYsSUFBSSxNQUFNLENBQUMsY0FBYyxFQUFFLEVBQUUsQ0FBQztZQUM1QixNQUFNLENBQUMsS0FBSyxDQUFDLDJCQUEyQixJQUFJLENBQUMsU0FBUyxDQUFDLFNBQVMsRUFBRSxTQUFTLEVBQUUsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFBO1FBQ3BGLENBQUM7UUFFRCxPQUFPO1lBQ0wsVUFBVSxFQUFFLEVBQUUsR0FBRyxTQUFTLENBQUMsU0FBUyxFQUFFLGFBQWEsRUFBRSxTQUFTLENBQUMsU0FBUyxFQUFFLEdBQUcsRUFBRTtZQUMvRSxZQUFZLEVBQUUsRUFBRSxHQUFHLFNBQVMsQ0FBQyxXQUFXLEVBQUUsYUFBYSxFQUFFLFNBQVMsQ0FBQyxXQUFXLEVBQUUsR0FBRyxFQUFFO1lBQ3JGLGdCQUFnQixFQUFFLFNBQVMsQ0FBQyxTQUFTO1NBQ3RDLENBQUE7SUFDSCxDQUFDO0lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztRQUNmLE1BQU0sQ0FBQyxLQUFLLENBQUMsb0RBQW9ELEVBQUUsS0FBSyxDQUFDLENBQUE7UUFDekUseUVBQXlFO1FBQ3pFLHlCQUF5QjtRQUN6QixPQUFPLEVBQUUsQ0FBQTtJQUNYLENBQUM7QUFDSCxDQUFDLENBQUE7QUF2Q1ksUUFBQSx3QkFBd0IsNEJBdUNwQyJ9